exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-red{border-color:red!important}.vs--searchable .vs__dropdown-toggle{border:none;width:100%}.form-input--v-select{padding:0}.form-input--v-select .vs__dropdown-toggle{padding:0 8px}.vs__selected-options{flex-basis:0}.input-filled{background-color:#fafafa;border-color:#42ec81;color:#3e3f42}", ""]);

// exports
